import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
var determineBackgroundColor = function (isDisabled, isIndeterminate, isSelected, isPressed, isHovered) {
    if (isDisabled || isIndeterminate)
        return 'background-secondary';
    if (isSelected)
        return 'primary';
    if (isPressed)
        return 'primary-80';
    if (isHovered)
        return 'primary-30';
    return 'white';
};
export var InternalCheckbox = function (_a) {
    var isDisabled = _a.isDisabled, isIndeterminate = _a.isIndeterminate, isSelected = _a.isSelected, isHovered = _a.isHovered, isPressed = _a.isPressed, isFocusVisible = _a.isFocusVisible, sizeVariant = _a.sizeVariant;
    var checkboxDimensions = sizeVariant === 'small' ? 14 : 18;
    var outlineDimensions = sizeVariant === 'small' ? 20 : 24;
    var backgroundColor = determineBackgroundColor(isDisabled, isIndeterminate, isSelected, isPressed, isHovered);
    var borderColor = isIndeterminate
        ? 'divider'
        : isDisabled || isSelected || isPressed
            ? 'none'
            : 'divider';
    var checkmarkColor = isDisabled ? 'divider-dark' : 'white';
    var checkmarkToRender = sizeVariant === 'small'
        ? smallCheckmark(checkmarkColor)
        : largeCheckmark(checkmarkColor);
    var indeterminateY = sizeVariant === 'small' ? 6 : 8;
    var indeterminateWidth = sizeVariant === 'small' ? 10 : 14;
    return (_jsxs("svg", { width: checkboxDimensions, height: checkboxDimensions, "aria-hidden": "true", style: {
            marginRight: '0.5rem',
            borderRadius: '3px',
            overflow: 'visible',
        }, "data-testid": "internal-checkbox", children: [_jsx("rect", { width: checkboxDimensions, height: checkboxDimensions, rx: '3px', ry: '3px', sx: {
                    fill: backgroundColor,
                    stroke: borderColor,
                    strokeWidth: 1,
                }, "data-testid": "internal-checkbox-background" }), isSelected && checkmarkToRender, isIndeterminate && (_jsx("rect", { x: 2, y: indeterminateY, width: indeterminateWidth, height: 2, sx: { fill: 'divider' }, "data-testid": "internal-checkbox-indeterminate" })), isFocusVisible && (_jsx("rect", { x: -3, y: -3, width: outlineDimensions, height: outlineDimensions, sx: {
                    fill: 'none',
                    stroke: 'divider-dark',
                    strokeWidth: 1,
                }, rx: '3px', ry: '3px', "data-testid": "internal-checkbox-outline" }))] }));
};
var smallCheckmark = function (color) {
    if (color === void 0) { color = 'white'; }
    return (_jsx("path", { transform: "translate(2, 3)", d: "M3.69956 5.75444L2.00888 4.04191L1.43518 4.62302L3.69956 6.91667L8.56481 1.98852L7.99112 1.40741L3.69956 5.75444Z", sx: {
            fill: color,
            stroke: color,
        }, "data-testid": "internal-checkbox-checkmark" }));
};
var largeCheckmark = function (color) {
    if (color === void 0) { color = 'white'; }
    return (_jsx("path", { transform: "translate(3, 4)", d: "M4.328 7.25571L2.15428 5.05389L1.41667 5.80103L4.328 8.75L10.5833 2.41381L9.84573 1.66666L4.328 7.25571Z", sx: {
            fill: color,
            stroke: color,
        }, "data-testid": "internal-checkbox-checkmark" }));
};
